import React from "react";
import createNavObj from "../../utils/createNavObj";
import createNavTree from "./createNavTree";
import styled from "styled-components";
import colors from "../../styles/colors";
import fonts from "../../styles/fonts";

const Wrapper = styled.div`
  width: 100%;
`;

const Hamburger = styled.div`
  @media screen and (max-width: 899px) {
    background-image: url('data:image/svg+xml;utf8,<svg aria-hidden="true" data-prefix="fas" data-icon="bars" class="svg-inline--fa fa-bars fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg>');
    background-repeat: no-repeat;
    display: block;
    height: 30px;
    position: relative;
    left: calc(100% - 30px);
    margin: 0px;
    transition: background-image 0.3s ease;
    width: 30px;

    &:hover {
      background-image: url('data:image/svg+xml;utf8,<svg aria-hidden="true" data-prefix="fas" data-icon="bars" class="svg-inline--fa fa-bars fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#8cd0c5" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg>');
      cursor: pointer;
    }

    > ul {
      display: none;
    }
  }
`;

const Nav = styled.div`
  font-family: ${fonts.header};
  text-transform: uppercase;
  width: 100%;
  z-index: 100;
  padding-left: 30px;
  font-family: ${fonts.header};
  font-size: 0.6875em;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  @media screen and (max-width: 899px) {
    -webkit-overflow-scrolling: touch;
    display: ${props => (props.showMobileNav ? `block` : `none`)};
    position: fixed;
    top: 76px;
    left: 0;
    width: 100%;
    background-color: ${colors.background};
    height: calc(100% - 75px);
    margin-top: 0;
    overflow: auto;
    font-size: 16px;
  }
`;

export default class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMobileNav: false,
      prevPath: this.props.path,
      path: this.props.path
    };
    this.toggleMobileNav = this.toggleMobileNav.bind(this);
  }

  componentWillReceiveProps(props) {
    this.setState({
      path: props.path,
      prevPath: this.state.path,
      showMobileNav: false
    });
    document.body.classList.remove("fixed");
  }

  toggleMobileNav(e) {
    e.preventDefault();
    if (this.state.showMobileNav == false) {
      document.body.classList.add("fixed");
    }
    this.setState({ showMobileNav: !this.state.showMobileNav });
  }

  render() {
    const { data, path } = this.props;
    const { showMobileNav, prevPath } = this.state;
    const navObj = createNavObj(data.allMarkdownRemark.edges);
    return (
      <Wrapper>
        <Hamburger
          onClick={e => {
            this.toggleMobileNav(e);
          }}
        />
        <Nav
          showMobileNav={showMobileNav}
          className={showMobileNav ? "showMobileNav" : ""}
        >
          {createNavTree(navObj, 0, {
            path,
            prevPath,
            change: path === prevPath
          })}
        </Nav>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/NavBar.js